var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4"},[(_vm.textLabel)?_c('TextLabel',_vm._b({staticClass:"d-block mb-0"},'TextLabel',_vm.textLabel,false)):_vm._e(),(_vm.textBlock)?_c('TextBlock',_vm._b({},'TextBlock',_vm.textBlock,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }